import React from 'react';

import { Card as AntdCard } from 'antd';
import { CardProps } from 'antd/lib/card';

const Card = (props: CardProps) => <AntdCard {...props} />;

export default Card;
